import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "../src/components/Header/Header";
import Footer from "../src/components/Footer/Footer";
import About from "./pages/about/about";
import Product from "./pages/Product/Product";
import Signup from "./pages/signup/signup";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import Myaccount from "./pages/Myaccount/Myaccount";
import Shop from "./pages/Shop/Shop";
import Wishlist from "./pages/Wishlist/Wishlist";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import ReturnAndRefund from "./pages/ReturnAndRefund/ReturnAndRefund";
import TermsAndCondition from "./pages/TermsAndCondition/TermsAndCondition";
import ShippingPolicy from "./pages/ShippingPolicy/ShippingPolicy";
import FAQ from "./pages/FAQ/FAQ";
import Dashboard from "./pages/Dashboard/Dashboard";
import Login from "./pages/login/Login";
import EditBlog from "./pages/EditBlog/EditBlog";
import CreateProduct from "./pages/createProduct/CreateProduct";
import Checkout from "./pages/Checkout/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation/OrderConfirmation";
import Cart from "./pages/Cart/Cart";
import contactInfoForDashboard from "./pages/contactInfoForDashboard/ContactInfoForDashboard";
import { ToastContainer } from "react-toastify";
import AdminProcess from "./pages/AdminProcess/AdminProcess";
import CreateCoupons from "./pages/CreateCoupons/CreateCoupons";
import UpdateCoupons from "./pages/UpdateCoupons/UpdateCoupons";
import Invoice from "./pages/Invoice/Invoice";
import ReturnAdminProcess from "./pages/ReturnAdminProcess/ReturnAdminProcess";
import ReturnConfirmation from "./pages/ReturnConfirmation/ReturnConfirmation";
import UpdateProduct from "./pages/UpdateProduct/UpdateProduct";
import ConfirmOrder from "./components/ConfirmOrder/ConfirmOrder";

import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    // <div className="App">
    <Router>
      <Header />
      <Routes>
        {/* <Route path="/signup" exact element={<Signup />} /> */}
        <Route path="/ConfirmOrder" exact element={<ConfirmOrder />} />
        <Route path="/login" exact element={<Login />} />
        <Route path="/about" exact element={<About />} />
        <Route path="/product/:id" element={<Product />} />
        <Route path="/contact" exact element={<Contact />} />
        <Route path="/" exact element={<Home />} />
        <Route path="/myaccount" exact element={<Myaccount />} />
        <Route path="/shop/:productId" exact element={<Shop />} />
        <Route path="/allProduct" exact element={<Shop />} />
        <Route path="/wishlist" exact element={<Wishlist />} />
        <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
        <Route path="/adminProcess/:orderId/" element={<AdminProcess />} />
        <Route
          path="/returnAdminProcess/:returnOrderId"
          element={<ReturnAdminProcess />}
        />
        <Route path="/createCoupons" element={<CreateCoupons />} />
        <Route
          path="/return-and-refund-policy"
          exact
          element={<ReturnAndRefund />}
        />
        <Route
          path="/terms-and-conditions"
          exact
          element={<TermsAndCondition />}
        />
        <Route path="/shippingPolicy" exact element={<ShippingPolicy />} />
        <Route path="/FAQ" exact element={<FAQ />} />
        <Route path="/dashboard" exact element={<Dashboard />} />

        {/* <Route path="/createBlog" exact element={<CreateBlog />} /> */}
        {/* <Route path="/editBlog/:id" exact element={<EditBlog />} /> */}
        <Route path="/createProduct" exact element={<CreateProduct />} />
        <Route path="/UpdateProduct/:id" exact element={<UpdateProduct />} />
        <Route
          path="/returnOrderConfirmation/:id"
          exact
          element={<ReturnConfirmation />}
        />
        <Route
          path="/updateCoupons/:couponId"
          exact
          element={<UpdateCoupons />}
        />
        <Route path="/checkout" exact element={<Checkout />} />
        <Route
          path="/orderConfirmation/:id"
          exact
          element={<OrderConfirmation />}
        />
        <Route path="/cart" exact element={<Cart />} />
        <Route
          path="/contactInfoForDashboard"
          exact
          element={<contactInfoForDashboard />}
        />
        <Route path="/invoice/:id" exact element={<Invoice />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <ToastContainer />
      <Analytics />
    </Router>
    // </div>
  );
}

export default App;
